module.exports = __webpack_public_path__ + "static/media/sub-card-label-9-over.e8546ca3.svg";